import { bootstrapApplication } from '@angular/platform-browser';
import { createAppConfig } from '@ui/shared/feature-config';
import { AppComponent } from './app/app.component';
import { EconomicDevelopmentMapDataService } from './app/services/data/economic-development-map-data.service';
import { EconomicDevelopmentMapMapDataService } from './app/services/economic-development-map-map-data.service';
import { SearchFilterConfigService } from './app/services/filter/search-filter-config.service';
import { DistrictSelectFilterConfigService } from './app/services/filter/district-select-filter-config.service';
import { CategorySelectFilterConfigService } from './app/services/filter/category-select-filter-config.service';
import { IndustrySelectFilterConfigService } from './app/services/filter/industry-select-filter-config.service';

bootstrapApplication(AppComponent, createAppConfig({
    mapDataStateService: EconomicDevelopmentMapMapDataService,
    filterItems: [
        SearchFilterConfigService,
        DistrictSelectFilterConfigService,
        CategorySelectFilterConfigService,
        IndustrySelectFilterConfigService,
    ],
    dataEndpoints: [
        EconomicDevelopmentMapDataService,
    ],
})).catch((err: unknown) => console.error(err));
